import { useState } from "react";

export default function Seccion1() {
  // Función para redirigir a WhatsApp
  const handleWhatsAppClick = () => {
    window.open("https://wa.me/+5492612444001", "_blank");
  };

  return (
    <div id="seccion1" className="relative min-h-screen flex items-center justify-center">
      {/* Contenedor de la imagen con opacidad */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: "url('/images/logo.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.1,  // Opacidad del fondo de la imagen
        }}
      />

      {/* Contenedor de texto superpuesto */}
      <div className="relative z-10 text-center px-6 max-w-2xl">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">
          ¿Necesitas ayuda profesional?
        </h2>
        <p className="text-lg text-black-800 mb-6">
          Ofrecemos servicios de pericias en incendios y asesoramiento especializado 
          para ayudarte a resolver tus problemas con la mayor precisión y eficiencia. 
          Contáctanos y recibe una atención personalizada.
        </p>
        <button
          onClick={handleWhatsAppClick}
          className="bg-green-500 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-green-600 transition"
        >
          Enviar mensaje por WhatsApp
        </button>
      </div>
    </div>
  );
}
